'use client';

// "You're live" earcon for pooled dialing: a single soft click (~40ms, quiet)
// played LOCALLY the moment the agent's line bridges to a contact — a cue,
// not a jingle. Generated with WebAudio (no asset); plays on the default
// output the agent already uses for calls. The customer can never hear it:
// it never touches the call media.

let context: AudioContext | null = null;

export function playBridgeChime(): void {
  try {
    context ??= new AudioContext();
    void context.resume();
    const now = context.currentTime;
    const osc = context.createOscillator();
    const gain = context.createGain();
    osc.type = 'sine';
    osc.frequency.value = 1000;
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.08, now + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.04);
    osc.connect(gain).connect(context.destination);
    osc.start(now);
    osc.stop(now + 0.05);
  } catch {
    // Audio blocked (no user gesture yet / no device) — the visual state flip
    // and the call audio itself remain the signal.
  }
}
